"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _permission = require("@/utils/permission");
var _reservation = require("@/api/reservation");
var _useProduct2 = require("@/hooks/use-product");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _useProduct = (0, _useProduct2.useProduct)(),
  handlerCreatFromUse = _useProduct.handlerCreatFromUse;
var _default = exports.default = {
  name: 'LabelList',
  data: function data() {
    return {
      activeName: '1',
      form: {
        serviceWorkOrderSwitch: false
      },
      tableData: [{
        name: '用户预约',
        status: true,
        disable: true,
        info: '  用户预约为必要节点，不可关闭'
      }, {
        name: '工单',
        key: 'serviceWorkOrderSwitch',
        info: '工单开启核销后会生成服务工单，关闭不生成工单，订单状态直接流转已收货、已服务 '
      }, {
        name: '结束服务',
        status: true,
        disable: true,
        info: '服务人员结束服务'
      }]
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['admin:merchant:reservation:to:store:info'])) this.getInfo();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //详情
    getInfo: function getInfo() {
      var _this = this;
      (0, _reservation.reservationStoreInfoApi)().then(function (res) {
        _this.form = _objectSpread({}, res);
      });
    },
    // 调取接口
    statusChange: function statusChange(row) {
      this.saveDate();
    },
    // 保存数据
    saveDate: function saveDate() {
      var _this2 = this;
      (0, _reservation.reservationStoreEditApi)(this.form).then(function (res) {
        _this2.$message.success('保存成功');
      });
    }
  }
};